import React from "react";
import {
  LicenseItemContainer,
  LicenseTitleContainer,
  TabInfoContentHeader,
  TabInfoContent,
  StyledHr
} from "pages/info/style";

export const Licenses: React.FC = () => {
  return (
    <div style={{ fontFamily: "Times, serif" }}>
      <LicenseItemContainer>
        <LicenseTitleContainer>
          <TabInfoContentHeader>MIT License</TabInfoContentHeader>
          <TabInfoContent>
            Copyright (c) 2013-present Jesse Squires
          </TabInfoContent>
        </LicenseTitleContainer>
        <StyledHr />
        <TabInfoContent padding="5px">
          <p>
            {` Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
	associated documentation files (the "Software"), to deal in the Software without restriction, including
	without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
	following conditions:`}
          </p>
          <p>{`The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.`}</p>
          <p>{`THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
	LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
	IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
	OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`}</p>
          <p>
            <a href="http://www.jessesquires.com" target="blank">
              http://www.jessesquires.com
            </a>
          </p>
        </TabInfoContent>
      </LicenseItemContainer>
      <LicenseItemContainer>
        <LicenseTitleContainer>
          <TabInfoContentHeader>The MIT License</TabInfoContentHeader>
          <TabInfoContent>
            Copyright © 2015 Krunoslav Zaher All rights reserved
          </TabInfoContent>
        </LicenseTitleContainer>
        <StyledHr />
        <TabInfoContent padding="5px">
          <p>
            {`Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:`}
          </p>
          <p>{`The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.`}</p>
          <p>{`THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`}</p>
        </TabInfoContent>
      </LicenseItemContainer>
      <LicenseItemContainer>
        <LicenseTitleContainer>
          <TabInfoContentHeader>The MIT License (MIT)</TabInfoContentHeader>
          <TabInfoContent>Copyright (c) 2014 kishikawa katsumi</TabInfoContent>
        </LicenseTitleContainer>
        <StyledHr />
        <TabInfoContent padding="5px">
          <p>
            {`Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:`}
          </p>
          <p>{`The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.`}</p>
          <p>{`THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.`}</p>
        </TabInfoContent>
      </LicenseItemContainer>

      <LicenseItemContainer>
        <LicenseTitleContainer>
          <TabInfoContentHeader>
            Copyright (c) 2009-2017 Olivier Poitrey
          </TabInfoContentHeader>
          <TabInfoContent>rs@dailymotion.com</TabInfoContent>
        </LicenseTitleContainer>
        <StyledHr />
        <TabInfoContent padding="5px">
          <p>
            {`Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is furnished
	to do so, subject to the following conditions:`}
          </p>
          <p>{`The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.`}</p>
          <p>{`THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.`}</p>
        </TabInfoContent>
      </LicenseItemContainer>
      <LicenseItemContainer>
        <LicenseTitleContainer>
          <TabInfoContentHeader>
            Copyright (c) 2016 Jörn Schoppe
          </TabInfoContentHeader>
          <TabInfoContent>joern@pixeldock.com</TabInfoContent>
        </LicenseTitleContainer>
        <StyledHr />
        <TabInfoContent padding="5px">
          <p>
            {`Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:`}
          </p>
          <p>{`The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.`}</p>
          <p>{`THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.`}</p>
        </TabInfoContent>
      </LicenseItemContainer>
      <LicenseItemContainer>
        <LicenseTitleContainer>
          <TabInfoContentHeader>
            Copyright (c) 2016 SwiftKick Mobile LLC
          </TabInfoContentHeader>
          <TabInfoContent>{null}</TabInfoContent>
        </LicenseTitleContainer>
        <StyledHr />
        <TabInfoContent padding="5px">
          <p>
            {`Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:`}
          </p>
          <p>{`The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.`}</p>
          <p>{`THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`}</p>
        </TabInfoContent>
      </LicenseItemContainer>
      <LicenseItemContainer>
        <LicenseTitleContainer>
          <TabInfoContentHeader>The MIT License (MIT)</TabInfoContentHeader>
          <TabInfoContent>Copyright (c) 2015 Lei Wang</TabInfoContent>
        </LicenseTitleContainer>
        <StyledHr />
        <TabInfoContent padding="5px">
          <p>
            {`Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:`}
          </p>
          <p>{`The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.`}</p>
          <p>{`THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`}</p>
        </TabInfoContent>
      </LicenseItemContainer>
      <LicenseItemContainer>
        <LicenseTitleContainer>
          <TabInfoContentHeader>The MIT License (MIT)</TabInfoContentHeader>
          <TabInfoContent>
            Copyright (c) 2014-2015 Vicc Alexander
          </TabInfoContent>
        </LicenseTitleContainer>
        <StyledHr />
        <TabInfoContent padding="5px">
          <p>
            {`Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:`}
          </p>
          <p>{`The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.`}</p>
          <p>{`THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`}</p>
        </TabInfoContent>
      </LicenseItemContainer>
    </div>
  );
};
